import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const LaneSheetHeatAthletesStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const LaneSheetHeatAthletesContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <LaneSheetHeatAthletesStateContext.Provider value={stateHook}>
      {children}
    </LaneSheetHeatAthletesStateContext.Provider>
  );
};

export default LaneSheetHeatAthletesContextProvider;